import React, { useState, FunctionComponent, useEffect, useCallback } from 'react';
import { Presentation } from './presentation';

type Props = {
  onChangedBody: (name: string, value: string) => void;
  gender: string;
  target: string;
};

export const Component: FunctionComponent<Props> = ({
  onChangedBody,
  gender,
  target,
}) => {
  const [currentGender, setCurrentGender] = useState<string>('');
  const genders = ['男性', '女性'];

  useEffect(() => {
    setCurrentGender(gender);
  }, [gender]);

  const handleChange = useCallback((selected: string) => {
    onChangedBody(target, selected);
  }, [onChangedBody, target]);

  return (
    <Presentation
      genders={genders}
      currentGender={currentGender}
      handleChange={handleChange}
    />
  );
};
